import ConjTable from './ConjTable';

export default ConjTable;



// WEBPACK FOOTER //
// ./src/components/ConjTable/index.js